var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-textarea", {
    ref: "textarea",
    staticClass: "pa-4",
    attrs: {
      value: _vm.value,
      label: _vm.label,
      "auto-grow": "",
      outlined: "",
      rules: _vm.noteRules,
      autofocus: _vm.autofocus,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
      "update:error": function ($event) {
        return _vm.validate($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }